import React from "react"

import Layout from "../components/global/Layout"
import Hero from "../components/block/Hero"
import MediaFeatureSVG from "../components/block/MediaFeatureSVG"
import CardFeature from "../components/block/CardFeature"
import Card from "../components/block/Card"
import SEO from "../components/global/SEO"

import {
  faAnalytics,
  faSmilePlus,
  faUserPlus,
} from "@fortawesome/pro-duotone-svg-icons"

import accessAccount from "../images/illustration/access-account.svg"
import confirm from "../images/illustration/confirm.svg"
import businessDecisions from "../images/illustration/business-decisions.svg"
import dropdownMenu from "../images/illustration/dropdown-menu.svg"
import chatting from "../images/illustration/chatting.svg"

export default function OurUserTestingPage() {
  return (
    <div>
      <Layout>
        <SEO
          title="The User Testing Experts"
          description="Explore user needs, test your value proposition, diagnose usability issues, optimise your user journeys and generate a higher return."
        />
        <Hero
          title="Learn what is working well, what isn’t and most importantly, why"
          content="Remove confusion and friction, optimise your user journeys and generate a higher return."
        />
        <MediaFeatureSVG src={chatting}>
          <h2>Explore user needs</h2>
          <ul>
            <li>What are their wants, needs and expectations?</li>
            <li>How well are these being met? </li>
            <li>What are their pain points?</li>
          </ul>
        </MediaFeatureSVG>
        <MediaFeatureSVG
          src={accessAccount}
          backgroundColorOverride={props => props.theme.shade[90]}
          reverse
        >
          <h2>Test your value proposition</h2>
          <ul>
            <li>How well is your proposition communicated? </li>
            <li>Do users understand your proposition?</li>
            <li>What information is missing?</li>
          </ul>
        </MediaFeatureSVG>
        <MediaFeatureSVG src={confirm}>
          <h2>Diagnose usability issues</h2>
          <ul>
            <li>How well are users able to perform tasks?</li>
            <li>Where does any confusion and friction arise?</li>
            <li>How can the experience be improved? </li>
          </ul>
        </MediaFeatureSVG>
        <MediaFeatureSVG
          src={businessDecisions}
          backgroundColorOverride={props => props.theme.shade[90]}
          reverse
        >
          <h2>Assess your experience</h2>
          <ul>
            <li>How does it feel to use your solution?</li>
            <li>Is it a positive experience?</li>
            <li>How does that reflect on your brand?</li>
          </ul>
        </MediaFeatureSVG>
        <MediaFeatureSVG src={dropdownMenu}>
          <h2>Encourage user ideation</h2>
          <ul>
            <li>How would users improve your solution?</li>
            <li>What features would users add?</li>
            <li>What other ideas do users have?</li>
          </ul>
        </MediaFeatureSVG>
        <CardFeature
          backgroundColorOverride={props => props.theme.shade[90]}
          title="Our work increases"
          content="the key metrics you depend upon"
          postContent="Find out more about how your project will be designed, run, analysed and how the findings will be reported back to you."
          buttonText="How we do it"
          buttonLink="/how-we-do-it/"
          cards={
            <>
              <Card icon={faAnalytics}>
                <h3>Optimised</h3>
                <ul>
                  <li>Conversion Rates</li>
                  <li>Customer Acquisition</li>
                  <li>Online Sales</li>
                </ul>
              </Card>
              <Card icon={faUserPlus}>
                <h3>More</h3>
                <ul>
                  <li>Registrations</li>
                  <li>Subscribers</li>
                  <li>Enquiries</li>
                </ul>
              </Card>
              <Card icon={faSmilePlus}>
                <h3>Higher</h3>
                <ul>
                  <li>User Satisfaction</li>
                  <li>User Engagement</li>
                  <li>User Loyalty</li>
                </ul>
              </Card>
            </>
          }
        />
      </Layout>
    </div>
  )
}
